<mat-card class='light' style="height: 100%;">
    <mat-card-header>
        <mat-card-title class="view-card-title">
          <h1>seller enquiries</h1>
        </mat-card-title>
    </mat-card-header>
    <mat-toolbar class="primary">
      <mat-toolbar-row>
        <button mat-mini-fab style="margin-right:10px; background-color:#a28b6e" >
          <mat-icon>search</mat-icon>
        </button>
        <button mat-mini-fab style="margin-right:10px; background-color:darkgray" >
          <mat-icon>refresh</mat-icon>
        </button>
  
        <span class="title-spacer"></span>
        <mat-form-field appearance="standard" class="search-form-fileld">
          <mat-label>Filter</mat-label>
          <!-- <input matInput (keyup)="applyFilter($event.target.value)"> -->
          <mat-icon>filter_list</mat-icon>
        </mat-form-field>
  
      </mat-toolbar-row>
    </mat-toolbar>

    <mat-table #table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="ID">
        <mat-header-cell *matHeaderCellDef mat-sort-header> ID </mat-header-cell>
        <mat-cell *matCellDef="let sellerenquiries"> {{sellerenquiries.id}} </mat-cell>
      </ng-container>
        <ng-container matColumnDef="phone">
          <mat-header-cell *matHeaderCellDef mat-sort-header> phone </mat-header-cell>
          <mat-cell *matCellDef="let sellerenquiries"> {{sellerenquiries.phone}} </mat-cell>
        </ng-container>     
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header> name </mat-header-cell>
          <mat-cell *matCellDef="let sellerenquiries"> {{sellerenquiries.name}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="car">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Car </mat-header-cell>
          <mat-cell *matCellDef="let sellerenquiries"> {{sellerenquiries.car1}} &nbsp;{{sellerenquiries.variant1}} <br> {{sellerenquiries.car2}}&nbsp;{{sellerenquiries.variant2}} <br> {{sellerenquiries.car3}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef mat-sort-header> status </mat-header-cell>
          <mat-cell *matCellDef="let sellerenquiries"> {{sellerenquiries.status}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Source">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Source </mat-header-cell>
          <mat-cell *matCellDef="let sellerenquiries"> {{sellerenquiries.source}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="DateCreated">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Created on </mat-header-cell>
          <mat-cell *matCellDef="let sellerenquiries"> {{sellerenquiries.created_on}} </mat-cell>
        </ng-container>
        <!-- <ng-container matColumnDef="last_updated">
          <mat-header-cell *matHeaderCellDef mat-sort-header> last updated Date </mat-header-cell>
          <mat-cell *matCellDef="let sellerenquiries"> {{sellerenquiries.last_updated}} </mat-cell>
        </ng-container> -->
        <ng-container matColumnDef="last_updated_by_user">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Created By </mat-header-cell>
          <mat-cell *matCellDef="let sellerenquiries"> {{sellerenquiries.created_by_name}} </mat-cell>
        </ng-container>   
        <ng-container matColumnDef="enquiryID">
          <mat-header-cell *matHeaderCellDef style="justify-content:right;">
            <!-- <button mat-button style="color:white; background-color:darkgrey" (click)="resetListFilter()">Reset</button> -->
          </mat-header-cell>
          <mat-cell *matCellDef="let sellerenquiries" style="justify-content:right;">
            <button mat-mini-fab style="background-color:teal; min-height: 30px;   margin: 5px;"
              [routerLink]="['../addeditenquiry',{'enquiryID':sellerenquiries.enquiryID}]">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-mini-fab style="background-color:lightblue; min-height: 30px;  margin: 5px;"
              [routerLink]="['../enqresponses',{'enquiryID':sellerenquiries.enquiryID,'name':sellerenquiries.name,'car1':sellerenquiries.car1,
              'varient1':sellerenquiries.variant1,'car2':sellerenquiries.car2,'varient2':sellerenquiries.varient2,'car3':sellerenquiries.car3}]">
              <mat-icon>note</mat-icon>
            </button>
            <button mat-mini-fab style="background-color:lightblue; min-height: 30px;  margin: 5px;">
              <!-- (click)="openDialog(sellerenquiries.enquiryID)"> -->
              <mat-icon>delete</mat-icon>
            </button>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
      <mat-paginator #paginator [pageSize]="10" [pageSizeOptions]="[5, 10]">
      </mat-paginator>    
</mat-card>